import type { DisciplineFilesStore } from './interfaces'

import { emptyDisciplineFilesFilters } from '../../../lib/discipline-files-query'

export const actions = {
  setLoading (this: DisciplineFilesStore, payload: DisciplineFilesStore['loading']): void {
    this.loading = payload
  },
  setPacks (this: DisciplineFilesStore, payload: DisciplineFilesStore['packs']): void {
    this.packs = payload
  },
  setTasks (this: DisciplineFilesStore, payload: DisciplineFilesStore['tasks']): void {
    this.tasks = payload
  },
  setMeta (this: DisciplineFilesStore, payload: DisciplineFilesStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: DisciplineFilesStore, payload: DisciplineFilesStore['filters']): void {
    this.filters = payload
  },
  patchFilters (this: DisciplineFilesStore, payload: Partial<DisciplineFilesStore['filters']>): void {
    this.filters = { ...this.filters, ...payload }
  },
  resetFilters (this: DisciplineFilesStore): void {
    this.filters = emptyDisciplineFilesFilters()
  },
  setCurrentPage (this: DisciplineFilesStore, payload: DisciplineFilesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: DisciplineFilesStore, payload: DisciplineFilesStore['perPage']): void {
    this.perPage = payload
  },
  openModal (
    this: DisciplineFilesStore,
    modal: NonNullable<DisciplineFilesStore['activeModal']>,
    packId: DisciplineFilesStore['activePackId'] = null,
  ): void {
    this.activeModal = modal
    this.activePackId = packId
  },
  closeModal (this: DisciplineFilesStore): void {
    this.activeModal = null
    this.activePackId = null
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: DisciplineFilesStore): void {
    this.packs = []
    this.tasks = []
    this.meta = null
  },
}
